/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Limits } from './Limits';
import {
    LimitsFromJSON,
    LimitsFromJSONTyped,
    LimitsToJSON,
} from './Limits';

/**
 * 
 * @export
 * @interface IndividualAccount
 */
export interface IndividualAccount {
    /**
     * Payment Account ID
     * @type {string}
     * @memberof IndividualAccount
     */
    id?: string;
    /**
     * Internal ID given by Lemonway (ID displayed on the Backoffice/Dashboard)
     * @type {number}
     * @memberof IndividualAccount
     */
    internalId?: number;
    /**
     * 
     * @type {Limits}
     * @memberof IndividualAccount
     */
    limits?: Limits;
}

/**
 * Check if a given object implements the IndividualAccount interface.
 */
export function instanceOfIndividualAccount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IndividualAccountFromJSON(json: any): IndividualAccount {
    return IndividualAccountFromJSONTyped(json, false);
}

export function IndividualAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndividualAccount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'internalId': !exists(json, 'internalId') ? undefined : json['internalId'],
        'limits': !exists(json, 'limits') ? undefined : LimitsFromJSON(json['limits']),
    };
}

export function IndividualAccountToJSON(value?: IndividualAccount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'internalId': value.internalId,
        'limits': LimitsToJSON(value.limits),
    };
}

